import ClientModule from "@/store/modules/client.module";
import { toaster } from "@/utilities/toaster";
import { Machine } from "xstate";
// Team detail > Correspondence: load the team's members, contacts and cells; one save for every member, then reload
const teamCorrespondenceMachine = Machine({
    id: "teamCorrespondence",
    initial: "loading",
    context: {
        teamId: "",
    },
    states: {
        loading: {
            invoke: {
                id: "loadingTeamCorrespondence",
                src: (context, event) => {
                    return ClientModule.GetTeamCorrespondence(context.teamId);
                },
                onDone: { target: "loaded" },
                onError: { target: "failed" },
            },
        },
        loaded: {
            on: {
                SAVE: { target: "saving" },
            },
        },
        failed: {
            on: {
                LOAD: { target: "loading" },
            },
        },
        saving: {
            invoke: {
                id: "savingTeamCorrespondence",
                src: (context, event) => {
                    return ClientModule.SaveTeamCorrespondence(event.payLoad);
                },
                onDone: { target: "loading", actions: "showSuccessMessage" },
                // Edits are kept; api.service has already shown the error toast
                onError: { target: "loaded" },
            },
        },
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            if (event.data && event.data.successMessages && event.data.successMessages.length) {
                toaster.ShowSuccess(event.data.successMessages[0]);
            }
        },
    },
    guards: {},
    activities: {},
    services: {},
});
export default teamCorrespondenceMachine;
